import React from 'react';
import styled from 'styled-components';

import { CallSkeleton as CallSkeletonIcon } from '@icons/communication';

interface ICallSkeleton {
  className?: string;
  height?: number;
}

const CallSkeleton = React.memo(
  ({ className = '', height = 135 }: ICallSkeleton) => (
    <StyledItem className={className} $height={height}>
      <StyledSkeletonIcon />
    </StyledItem>
  )
);

CallSkeleton.displayName = 'CallSkeleton';

const StyledItem = styled.div<{ $height: number }>`
  border-radius: 4px;
  border: 1px solid #919499;
  box-sizing: border-box;
  height: ${({ $height }) => `${$height}px`};
  padding: 10px 9px;
  margin-bottom: 10px;
  margin-right: 10px;
`;

const StyledSkeletonIcon = styled(CallSkeletonIcon)`
  width: 207px;
  height: 40px;
  animation: fade 0.1s ease;
  @keyframes fade {
    from {
      opacity: 0;
    }
  }
`;

export default CallSkeleton;
